module.exports = __webpack_public_path__ + "img/nav_icon_team_normal.9f4e6235.png";